import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';

export const LAST_CREATED_CAMPAIGN_ID = 'lastCreatedCampaignId';

export const useLastCreatedCampaignId = queryParamHookFactory(LAST_CREATED_CAMPAIGN_ID);
